import { useNavigate } from "react-router-dom";
import { trackSchedule } from "@/shared/utils/metaPixel";
import { SEO } from "@/shared/components/SEO";

export default function AdLandingPage1() {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/auth?mode=signup&trial=true", { replace: false, state: { from: "/lp/see-the-job" } });
  };

  const handlePricing = () => {
    navigate("/lp/pricing");
  };

  const handleBookDemo = () => {
    trackSchedule({ email: "" }, "Demo Request");
    window.open("https://link.strategicleadd.com/widget/booking/2l5we3GFpAygSb6ATQuW", "_blank");
  };

  return (
    <>
      <SEO title="See the Job Before You Roll — wlkthru" description="Send your customer a link. They show you the problem on video. You quote it from the shop — no app, no wasted drive." />
      <div style={{ fontFamily: "'Montserrat', sans-serif", color: "#020817", lineHeight: 1.6 }}>
        {/* Nav */}
        <nav style={{ padding: "20px 24px", background: "white", borderBottom: "1px solid #D9E4EF", position: "sticky", top: 0, zIndex: 100 }}>
          <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span style={{ fontFamily: "'League Spartan', sans-serif", fontSize: 28, fontWeight: 700, color: "#97AAF7" }}>wlkthru</span>
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <button onClick={handlePricing} style={{ background: "transparent", color: "#9CA3AF", border: "none", fontWeight: 500, cursor: "pointer", fontSize: 14 }}>
                Pricing
              </button>
              <button onClick={handleGetStarted} style={{ background: "#97AAF7", color: "white", border: "none", borderRadius: 10, padding: "10px 24px", fontWeight: 600, cursor: "pointer", fontSize: 14 }}>
                Start Free Trial
              </button>
            </div>
          </div>
        </nav>

        {/* Hero */}
        <section style={{ padding: "80px 24px", background: "linear-gradient(135deg, #F8F8FC 0%, #FFFFFF 100%)", textAlign: "center" }}>
          <h1 style={{ fontFamily: "'League Spartan', sans-serif", fontWeight: 700, fontSize: "clamp(36px, 5vw, 56px)", marginBottom: 24 }}>
            See the Job <span style={{ color: "#97AAF7" }}>Before You Roll</span>
          </h1>
          <p style={{ fontSize: 20, color: "#647488", marginBottom: 40, maxWidth: 600, marginLeft: "auto", marginRight: "auto" }}>
            Send your customer a link. They show you the problem on video. You quote it from the shop — no app, no wasted drive.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={handleGetStarted} style={{ background: "#97AAF7", color: "white", border: "none", borderRadius: 12, padding: "16px 32px", fontWeight: 600, cursor: "pointer", fontSize: 16, transition: "all 0.2s" }}>
              Start 15-Day Free Trial
            </button>
            <button onClick={handleBookDemo} style={{ background: "transparent", color: "#020817", border: "2px solid #D9E4EF", borderRadius: 12, padding: "16px 32px", fontWeight: 600, cursor: "pointer", fontSize: 16 }}>
              Book a Demo
            </button>
          </div>
        </section>

        {/* Value props */}
        <section style={{ padding: "60px 24px", background: "#F8F8FC" }}>
          <div style={{ maxWidth: 1200, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 40, textAlign: "center" }}>
            {[
              { stat: "Less Driving", desc: "Quote from the shop first" },
              { stat: "More Jobs Won", desc: "Respond faster than competitors" },
              { stat: "No Downloads", desc: "Customers tap a link — no app required" },
              { stat: "Instant Invoicing", desc: "Get paid while still on the call" },
            ].map((item) => (
              <div key={item.stat}>
                <h3 style={{ fontFamily: "'League Spartan', sans-serif", fontSize: 28, color: "#97AAF7", marginBottom: 8 }}>{item.stat}</h3>
                <p style={{ color: "#647488", fontSize: 14, textTransform: "uppercase", letterSpacing: 1 }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Benefits */}
        <section style={{ padding: "80px 24px" }}>
          <div style={{ maxWidth: 1200, margin: "0 auto", textAlign: "center" }}>
            <h2 style={{ fontFamily: "'League Spartan', sans-serif", fontWeight: 700, fontSize: 36, marginBottom: 60 }}>Built for Teams That Roll Trucks</h2>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 32 }}>
              {[
                { title: "Live Video Calls", body: "Connect instantly with customers by video. Understand the scope, bid the project, and close the deal before you load the truck." },
                { title: "No App Needed", body: "Customers tap a text link. No downloads, no friction — works on any phone." },
                { title: "Invoice Instantly", body: "Send invoices right after the call. Customers cover the fee — you keep every dollar." },
                { title: "Team Collaboration", body: "Your crew in the field, your dispatchers in the office — everyone stays connected." },
                { title: "Record Everything", body: "Automatically record walkthroughs for insurance claims, disputes, or training." },
                { title: "Works Anywhere", body: "Web, iOS, Android. Any device, any network, anywhere the job takes you." },
              ].map((card) => (
                <div key={card.title} style={{ padding: "40px 32px", background: "#F8F8FC", borderRadius: 12 }}>
                  <h3 style={{ fontFamily: "'League Spartan', sans-serif", fontSize: 22, marginBottom: 12 }}>{card.title}</h3>
                  <p style={{ color: "#647488" }}>{card.body}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section style={{ padding: "100px 24px", background: "#97AAF7", textAlign: "center", color: "white" }}>
          <h2 style={{ fontFamily: "'League Spartan', sans-serif", fontWeight: 700, fontSize: 36, marginBottom: 16 }}>Stop Driving Blind</h2>
          <p style={{ fontSize: 18, opacity: 0.9, marginBottom: 32 }}>Join hundreds of trades teams saving time and winning more jobs.</p>
          <button onClick={handleGetStarted} style={{ background: "white", color: "#97AAF7", border: "none", borderRadius: 12, padding: "16px 40px", fontWeight: 600, cursor: "pointer", fontSize: 16 }}>
            Get Started Free
          </button>
        </section>
      </div>
    </>
  );
}
